<template>
  <div>
    <generic-table
      ref="datatable"
      :title="$t('poker tournaments')"
      :columns="columns"
      :column_search="true"
      resource_url="/tournament/poker/datatables"
      mode="grid"
      grid_class="is-col-min-12"
      :page_length="25"
    >
      <template #item="item">
        <div class="card">
          <div class="card-image">
            <div
              class="is-pulled-right has-text-danger"
              :data-tooltip="$t('delete')"
              @click="remove(item)"
            >
              <span class="icon"><i class="fa fa-trash"></i></span>
            </div>
            <figure class="image is-64x64 m-auto" @click="view(item)">
              <v-lazy-image
                src="https://cdn-icons-png.freepik.com/512/8835/8835736.png"
              />
            </figure>
          </div>
          <div class="card-content px-0" @click="view(item)">
            <div class="media">
              <div class="media-content">
                <p class="title is-5 has-text-centered">
                  {{ format_date(item.date) }}
                </p>
                <div class="content">
                  <ol>
                    <li v-for="(player, pidx) in item.summary" :key="pidx">
                      {{ player.name }} - {{ player.score }}
                    </li>
                  </ol>
                </div>
                <!-- <pre>{{ item }}</pre> -->
              </div>
            </div>
            <div class="control">
              <div class="tags has-addons are-medium">
                <span class="tag is-dark">{{ $t("gambling pit") }}</span>
                <span class="tag is-info">{{
                  format_currency(item.total_pit)
                }}</span>
              </div>
            </div>
          </div>
          <div class="card-footer">
            <div class="card-footer-item" @click="register_game(item)">
              <span class="icon">
                <i class="fa fa-user"></i>
              </span>
              <span>{{ $t("register game") }}</span>
            </div>
            <div class="card-footer-item" @click="game_list(item)">
              <span class="icon">
                <i class="fa fa-list"></i>
              </span>
              <span>{{ $t("game list") }}</span>
            </div>
          </div>
        </div>
      </template>
      <template v-slot:buttons>
        <button class="button is-secondary is-rounded" @click="create">
          <span class="icon">
            <i class="fa fa-plus"></i>
          </span>
          <span>{{ $t("create") }}</span>
        </button>
      </template>
    </generic-table>
    <tournament-modal ref="tournament_modal" @success="refresh" />
    <game-modal ref="game_modal" @success="refresh" />
    <game-list-modal ref="game_list_modal" />
  </div>
</template>

<script>
import GenericTable from "@/components/generic_table/GenericTable.vue";
import {
  generate_datatables_buttons,
  confirm_deletion_dialog,
  del,
  post,
  error_message,
  format_date,
  format_currency,
} from "@/utils";
import TournamentModal from "./tournament_modal/Index.vue";
import GameModal from "./game_modal/Index.vue";
import GameListModal from "./game_list_modal/Index.vue";
import VLazyImage from "v-lazy-image";

export default {
  name: "TournamentsDatatable",
  components: {
    GenericTable,
    TournamentModal,
    VLazyImage,
    GameModal,
    GameListModal,
  },
  data() {
    let v = this;
    return {
      columns: [
        {
          title: v.$t("date"),
          name: "date",
          searchable: false,
          width: "15%",
          data: (row) => {
            return `<pre>${JSON.stringify(row, null, 2)}</pre>`;
            // return v.format_date(row.date) || "";
          },
        },
      ],
    };
  },
  methods: {
    format_date,
    format_currency,
    create() {
      let v = this;
      v.$refs.tournament_modal.show_modal();
    },
    refresh() {
      let v = this;
      v.$refs.datatable.refresh();
    },
    remove(item) {
      let v = this;
      confirm_deletion_dialog(
        v.$t("are you sure to delete tournament?"),
        v,
        () => {
          del("/tournament/poker", { uuid: item.uuid })
            .then(() => {
              v.refresh();
            })
            .catch((error) => {
              error_message(error);
            });
        }
      );
    },
    view(item) {
      let v = this;
      v.$refs.tournament_modal.view_modal(item.uuid);
    },
    register_game(tournament) {
      let v = this;
      v.$refs.game_modal.show_modal(tournament.uuid);
    },
    game_list(tournament) {
      let v = this;
      v.$refs.game_list_modal.show_modal(tournament.uuid);
    },
  },
  mounted() {
    this.refresh();
  },
};
</script>

<style></style>
